import { testId } from '../../utils';
import { Iconography } from '../primitives';
import clsx from 'clsx';
import React from 'react';

export type AlertVariant = 'error' | 'success';

type AlertIconProps = {
  variant: AlertVariant;
  'data-testid': string;
};

const AlertIcon: React.FC<AlertIconProps> = ({
  'data-testid': dataTestId,
  variant,
}) => {
  switch (variant) {
    case 'success':
      return (
        <Iconography
          {...testId(dataTestId)}
          variant="check_circle"
          className="text-base text-green-dark mt-[2px]"
        />
      );
    case 'error':
      return (
        <Iconography
          {...testId(dataTestId)}
          variant="error"
          className="text-base ttext-red-dark mt-[2px]"
        />
      );
    default:
      return;
  }
};

export type AlertProps = React.PropsWithChildren<{
  variant: AlertVariant;
  'data-testid': string;
  className?: string;
}>;

const Alert: React.FC<AlertProps> = ({
  variant,
  children,
  'data-testid': dataTestId,
  className,
}) => (
  <div
    role="alert"
    {...testId(dataTestId)}
    className={clsx(
      variant === 'success' && 'bg-green-light text-green-dark',
      variant === 'error' && 'bg-red-light text-red-dark',
      'rounded px-2 py-3',
      className,
    )}
  >
    <div
      {...testId(dataTestId, 'text')}
      className="text-xs flex gap-1 items-start"
    >
      <AlertIcon {...testId(dataTestId, 'icon')} variant={variant} />
      {children}
    </div>
  </div>
);

export default Alert;
